export default __webpack_public_path__ + "images/f8f8fbe47b95fc77ab67cd9a79650572-icon-custom-target.svg";